import moment from 'moment';

export const getCurrentDateAtUpcomingHour = () =>
  moment().add(59, 'minutes').startOf('hour');
